<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar dense elevation="1" rounded color="secondary">
                    <v-breadcrumbs class="ms-n6" :items="[{text: 'Purchasing & Ordering'}, {text: 'Ordering'} ,{text: 'Create Account',}]" large/>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet elevation="1" rounded>
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Create Account
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-content-save" tooltip="Save" @click="handleSave"/>
                            <PIconBtn icon="mdi-cancel" tooltip="Discard" @click="handleDiscard"/>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-divider></v-divider>
                    <SupplierAccountForm
                        class="ma-3"
                        v-if="!supplierLoading"
                        :supplier-id="supplierId"
                        ref="form"
                        @submit="handleSubmit"
                        />
                </v-sheet>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"></PAlert>
        <LoadingOverlay :value="loading"/>
    </v-container>
</template>

<script>
import PAlert from './../../components/common/PAlert.vue'
import LoadingOverlay from './../../components/common/LoadingOverlay.vue'
import { mapActions } from 'vuex';
import PIconBtn from '../../components/common/PIconBtn.vue';
import SupplierAccountForm from '../../components/purchase/SupplierAccountForm.vue';
import { v4 as uuid } from 'uuid';

export default {
    name: "SupplierAccountCreateView",
    components: {
        PIconBtn,
        SupplierAccountForm,
        PAlert,
        LoadingOverlay
    },
    data() {
        return {
            supplierId: null,
            alert: {
                title: "Alert",
                content: "Are you sure",
                value:  false,
                callback: null
            },
            loading: false,
            supplierLoading: false,
            idempotentKey: null
        }
    },
    methods: {
        ...mapActions({
            snackbar: "ui/snackbar/show",
            create: "purchase/supplierAccount/create",
            findByID: "purchase/supplier/find",
            pushSupplier: "purchase/supplier/push"
        }),
        handleSave() {
            this.alert = { ...this.alert, value: true, content: "Are you sure you want to save", callback: this.save }
        },
        save() {
            this.$refs.form.submit()
        },
        handleSubmit(form) {
            this.loading = true;
            this.create({...form, idempotentKey: this.idempotentKey}).then(response => {
                this.snackbar({ text: "Supplier Account Create" ,color: "green"})
                this.$router.push({ name: "SupplierAccountDisplay", params: { id: response.data.id} })
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({ text: message, color: "error" })
            }).finally(() => {
                this.loading = false;
            });
        },
        handleDiscard() {
            this.alert = { ...this.alert, value: true, content: "Are you sure you want to Discard", callback: this.discard }
        },
        discard() {
            this.$router.back()
        },
        fetchSupplier() {
            this.supplierLoading = true;
            this.findByID(this.supplierId).then(response => {
                this.pushSupplier(response.data);
            }).catch(error => {
                let message = error.response ? error.response.data.message : error;
                this.snackbar({ text: message, color: "error" })
            }).finally(() => this.supplierLoading = false)

        },
    },
    mounted() {
        if(this.$route.query.supplier) {
            this.supplierId = this.$route.query.supplier;
            this.fetchSupplier();
        }
        this.idempotentKey = uuid();
    }
}
</script>

<style>

</style>